"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentTerminalControlPaymentWithPayloadValidation = void 0;
const PaymentTerminalControlEMVCardPayloadValidation_1 = require("./PaymentTerminalControlEMVCardPayloadValidation");
const PaymentTransactionValidation_1 = require("./PaymentTransactionValidation");
class PaymentTerminalControlPaymentWithPayloadValidation {
    static isValid(entity) {
        // Validate entity.payment_transaction for existence and correct type.
        if (entity.payment_transaction == undefined)
            return false;
        if (!PaymentTransactionValidation_1.PaymentTransactionValidation.isValid(entity.payment_transaction))
            return false;
        // Validate entity.card_payload for existence and correct type.
        if (entity.card_payload == undefined)
            return false;
        if (!PaymentTerminalControlEMVCardPayloadValidation_1.PaymentTerminalControlEMVCardPayloadValidation.isValid(entity.card_payload))
            return false;
        return true;
    }
}
exports.PaymentTerminalControlPaymentWithPayloadValidation = PaymentTerminalControlPaymentWithPayloadValidation;
